import React, { useState } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PageTransition } from "./components/PageTransition";
import { GateEntrance } from "./components/GateEntrance";
import { Toaster } from "./components/ui/sonner";
import { NowPlayingBar } from "./components/NowPlayingBar";

// Import pages
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { AlbumPage } from "./pages/AlbumPage";
import { MusicPage } from "./pages/MusicPage";
import { VideosPage } from "./pages/VideosPage";
import { GalleryPage } from "./pages/GalleryPage";
import { BookingPage } from "./pages/BookingPage";
import { NewsletterPage } from "./pages/NewsletterPage";
import AdminPage from "./pages/AdminPage";
import { StorePage } from "./pages/StorePage";

function App() {
  const [showGate, setShowGate] = useState(true);
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  const handleGateComplete = () => {
    setShowGate(false);
  };

  return (
    <div className="App">
      {showGate && !isAdminPage && <GateEntrance onComplete={handleGateComplete} />}
      <div className={`transition-opacity duration-300 ${!isAdminPage && showGate ? 'opacity-0' : 'opacity-100'}`}>
        {!isAdminPage && <Header />}
        <PageTransition>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/album" element={<AlbumPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/store" element={<StorePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </PageTransition>
        {!isAdminPage && <Footer />}
        {!isAdminPage && <NowPlayingBar />}
      </div>
      <Toaster />
    </div>
  );
}

export default App;
